// Module
var code = "<abx-input-section abx-form-name=\"{{vm.formName}}\" abx-editable=\"vm.field.is_editable && !vm.readonly\" abx-submit=\"vm.onSave(vm.value)\"> <abx-tree-input name=\"tree\" ng-model=\"vm.value\" ng-required=\"vm.field.is_required\" abx-label=\"{{vm.field.name}}\" abx-tree=\"vm.options\"> </abx-tree-input> </abx-input-section> ";
// Exports
module.exports = code;